import { Paper } from "@mantine/core";
import { Dropdown, Input, Menu, Select, DatePicker } from "antd";
import React, { useState } from "react";
import { isWithinDateRange } from "../../helpers/date-range";

export default function LaboratoriesFilterBar({
  data,
  onFilter,
  onReset,
  excelExport,
}) {
  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [filters, setFilters] = useState({
    search: "",
    requestType: null,
    laboratory: null,
    dateRange: null,
  });

  const onMenuClick = (e) => {
    if (e.key === "1") excelExport();
    // if ( e.key === "2" ) alert( 'pdf' );
    // if ( e.key === "3" ) alert( 'email' );
  };

  const applyFilters = (newFilters) => {
    setFilters(newFilters);

    let filteredData = data || [];

    if (newFilters.search) {
      const searchTerm = newFilters.search.toLowerCase();
      filteredData = filteredData.filter((p) =>
        [
          p?.consultation?.patient?.firstName,
          p?.consultation?.patient?.lastName,
          p?.consultation?.patient?.gender,
        ].some((field) => (field || "").toLowerCase().includes(searchTerm))
      );
    }

    if (newFilters.requestType)
      filteredData = filteredData.filter(
        (d) => d?.requestType === newFilters.requestType
      );

    if (newFilters.laboratory)
      filteredData = filteredData.filter(
        (d) => d?.laboratory?.loboratoryName === newFilters.laboratory
      );

    if (newFilters.dateRange)
      filteredData = filteredData.filter((d) =>
        isWithinDateRange(d?.createdAt, newFilters.dateRange)
      );

    onFilter(filteredData);
  };

  const handleSearchChange = (e) =>
    applyFilters({ ...filters, search: e.target.value });

  const handleRequestTypeChange = (v) =>
    applyFilters({ ...filters, requestType: v });

  const handleLaboratoryChange = (v) =>
    applyFilters({ ...filters, laboratory: v });

  const handleDateRangeChange = (dates) =>
    applyFilters({ ...filters, dateRange: dates });

  const handleReset = () => {
    setFilters({
      search: "",
      requestType: null,
      laboratory: null,
      dateRange: null,
    });
    onReset();
  };

  const menu = (
    <Menu
      onClick={onMenuClick}
      items={[
        {
          key: "1",
          label: (
            <>
              <span className="bi bi-file-excel me-2"></span>
              Excel
            </>
          ),
        },
        // {
        //     key: "2",
        //     label: <>
        //         <span className='bi bi-file-pdf me-2'></span>
        //         PDF
        //     </>
        // },
        // {
        //     key: "3",
        //     label: <>
        //         <span className='bi bi-envelope me-2'></span>
        //         Email
        //     </>
        // },
      ]}
    />
  );

  return (
    <Paper className="border p-3 d-flex justify-content-between">
      <div className="d-flex align-items-center gap-2">
        <Search
          style={{ maxWidth: "200px" }}
          value={filters.search}
          onChange={handleSearchChange}
          title="search labs"
          placeholder="search labs"
        />

        <RangePicker
          style={{ maxWidth: "250px" }}
          value={filters.dateRange}
          onChange={handleDateRangeChange}
          placeholder={["Start Date", "End Date"]}
          format="YYYY-MM-DD"
        />

        <Select
          style={{ minWidth: "140px" }}
          name="byRequest"
          allowClear
          value={filters.requestType || undefined}
          onChange={handleRequestTypeChange}
          placeholder="lab requests">
          {[...new Set(data?.map((d) => d?.requestType))]
            .filter(Boolean)
            .map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
        </Select>

        <Select
          style={{ minWidth: "140px" }}
          name="byLab"
          allowClear
          value={filters.laboratory || undefined}
          onChange={handleLaboratoryChange}
          placeholder="partner lab">
          {[...new Set(data?.map((d) => d?.laboratory?.loboratoryName))]
            .filter(Boolean)
            .map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
        </Select>
      </div>
      <div className="d-flex">
        <Dropdown overlay={menu}>
          <button className="app-btn btn-prim d-flex align-items-center">
            <span className="bi bi-file-earmark-arrow-down me-2"></span>
            Export to
          </button>
        </Dropdown>
        {/* <button
                    className="app-btn btn-prim d-flex mx-2 align-items-center">
                    <span className="bi bi-list me-2"></span>
                    More Filters
                </button> */}
        <button
          onClick={handleReset}
          className="app-btn btn-prim d-flex align-items-center ms-2">
          <span className="bi bi-arrow-clockwise me-2"></span>
          Reset filters
        </button>
      </div>
    </Paper>
  );
}
